export const NAME = 'listingList'
